import { AsyncPortal } from "@circle-react-uikit/AsyncPortal";

import { coverImageSelector } from "../constants";
import { CoverImage } from "./CoverImage";

interface MobileCoverImageProps {
  coverImageUrl: string;
  thumbnailImageUrl?: string;
}

export const MobileCoverImage = ({
  thumbnailImageUrl,
  coverImageUrl,
}: MobileCoverImageProps) => {
  const url = thumbnailImageUrl || coverImageUrl;
  const isThumbnail = Boolean(thumbnailImageUrl);
  return (
    <AsyncPortal selectorQuery={coverImageSelector}>
      <CoverImage url={url} thumbnail={isThumbnail} />
    </AsyncPortal>
  );
};
